export enum ProviderType {
  SF = 'salesforce',
  HS = 'hubspot',
  CSV = 'csv',
  HubspotList = 'hubspot/list',
  SalesforceReport = 'salesforce/report',
  SalesforceSoql = 'salesforce/soql',
  SalesforceDebugReport = 'salesforce/debug-report',
}

export enum AccountType {
  SF = 'salesforce',
  HS = 'hubspot',
  SFGC = 'salesforce-gc',
  SFEC = 'salesforce-ec',
}

export enum Operation {
  PULL = 'pull',
  INSERT = 'insert',
  UPDATE = 'update',
  DELETE = 'delete',
}

export interface FilterCondition {
  fieldName: string;
  type: string;
  operator: string;
  value: any;
  joinOperator: string;
}

export interface ColumnFieldMapping {
  columnName: string;
  fieldName: string;
  alternativeColumnName?: string;
}

export type Flowstep <T = Record<string, any>> = {
  id: any;
  name: string;
  flowId?: string;
  errorReaction: string;
  operation: Operation;
  provider: ProviderType;
  options: Record<string, any>;
  providerOptions: T;
  version: string;
};

export type ProviderOptions  = {
  objectType: string;
  objectProps: string[];
  excludedProps?: string[];
}

type OldFlowstep = Record<string, any>;
type NewFlowstepFormat = Record<string, any> & { originalFlowstep: Flowstep };
export type MigrationFlowstep = OldFlowstep | NewFlowstepFormat;

export const isNewFlowstepFormat = (flowstep: MigrationFlowstep) => flowstep.version >= 4;

export enum PullMode {
  OVERWRITE = 'overwrite',
  APPEND = 'append',
  NEW_SHEET = 'new-sheet',
}
